import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";

function Empresa() {
  const [empreses, setEmpreses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEmpreses = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/Empreses.php`);
        const data = await response.json();
        setEmpreses(data); // Carrega les dades des de l'endpoint
      } catch (error) {
        console.error("Error carregant empreses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpreses();
  }, []);

  return (
    <div>
      <h2>Llista de Fulls de Treball</h2>
      {loading ? (
        <p>Carregant empreses...</p>
      ) : empreses.length > 0 ? (
        <ul>
          {empreses.map((empresa) => (
            <li key={empresa.IdEmpresa}>
              <strong>{empresa.Nom}</strong> ({empresa.NomComercial}) - {empresa.CIF_DNI}
            </li>
          ))}
        </ul>
      ) : (
        <p>No s'ha trobat cap empresa.</p>
      )}
    </div>
  );
}

export default Empresa;
